import React from 'react';
import { Button, CircularProgress } from '@material-ui/core';

const JMuiButton = (props) => {
  const { loading, children, ...otherProps } = props;
  return (
    <Button 
      {...otherProps} 
      startIcon={loading ? null : otherProps.startIcon}
      disabled={loading || otherProps.disabled}
    >
      {loading && <CircularProgress color='inherit' size={20} style={{ marginRight: 8 }} /> }
      {children}
    </Button>
  );
};
export default JMuiButton;